import { Component, OnDestroy, OnInit } from '@angular/core';
import { Validators, FormGroup, FormsModule, ReactiveFormsModule, FormControl } from '@angular/forms';
import { Router, RouterModule, Params, ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { environment } from '../../../environments/environment';
import { Subject } from 'rxjs';

import { AppService } from '../../app.service';
import { AuthService } from '../../auth.service';
import { LoaderService } from '../../loader.service';
import { LayoutService } from '../../layout.service';
import { HomeService } from '../../home/home.service';

import { HeaderComponent } from '../../header/header.component';
import { LoaderComponent } from '../../shared/loader/loader.component';
import { FooterComponent } from '../../footer/footer.component';

import { User } from '../../shared/interfaces/user';
import { loginOrEmailOrPhoneValidator } from '../../shared/validators/loginOrEmailOrPhoneValidator';
import { ClickAnywhereDirective } from '../../click-anywhere.directive';

@Component({
  selector: 'app-auth-login',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, RouterModule, HeaderComponent, CommonModule, LoaderComponent, FooterComponent, ClickAnywhereDirective],
  templateUrl: './auth-login.component.html',
  styleUrls: ['./auth-login.component.scss'],
})
export class AuthLoginComponent implements OnInit, OnDestroy {
  loading$ = this.loaderService.loading$;
  authFormGroup: FormGroup
  remember = false
  wrongCredential = false
  showPassword = false
  loading = false
  serviceName = environment.serviceName
  queryParams: Params | null | undefined = null
  inputs: { login: boolean | null, password: boolean | null } = { login: null, password: null }
  formStatus = 'INVALID'
  isDesktop = this.layoutService.isDesktop
  private readonly _destroyed = new Subject<void>()
  loggedIn = false
  registrationNeeded$ = this.authService.registrationNeeded$

  constructor(
    private authService: AuthService,
    private router: Router,
    private appService: AppService,
    private loaderService: LoaderService,
    private layoutService: LayoutService,
    private homeService: HomeService,
    private route: ActivatedRoute
  ) {
    // A SUPPRIMER : pour les tests
    this.inputs.login = true
    this.inputs.password = true
    // A SUPPRIMER : pour les tests

    this.authFormGroup = new FormGroup({
      loginCtrl: new FormControl('', [Validators.required, loginOrEmailOrPhoneValidator()]),
      passwordCtrl: new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(25)]),
    });

    this.appService.setPage('login');
  }

  ngOnInit() {
    console.log('ngoninit')
    this.loaderService.hide()

    this.loggedIn = this.authService.isAuthenticated()

    if(this.loggedIn)  {
      this.router.navigate(['/home'])
      this.homeService.pageDisplayed.next('home')
    }

    this.authFormGroup.statusChanges.subscribe(res => {
      this.formStatus = res
    })

    this.route.queryParams.subscribe(params => {
      this.authFormGroup.controls['loginCtrl'].setValue(params['user'])
    })
  }

  getClickNature(clickNature: string){
    if(clickNature === 'anywhere'){
      this.authService.setRegistrationAsUnneeded()
    }
  }

  onSubmit(): void {
    console.log('onsubmit')
    this.loaderService.show()
    const data = this.authFormGroup.value

    this.authService.logged$.next(true)
   
    this.router.navigate(['/home'], { queryParams: this.queryParams })

    this.authService
      .authLogin(data.loginCtrl.trim().toLowerCase(), data.passwordCtrl)
      .subscribe({
        next: ((res: User | null) => {
          this.authService.user.next(res)
          this.authService.logged$.next(true)

          if(!JSON.parse(this.authService.get('user')).main_photo){
            this.router.navigate(['/upload-photo'], { queryParams: this.queryParams })
          } else {
            this.router.navigate(['/home'], { queryParams: this.queryParams })
            this.homeService.pageDisplayed.next('home')
            this.homeService.toggleSidenav.next(false)
          }

          this.loaderService.hide()
        }), 
        error: (err => {
          console.log(err)
          if(err.error && err.error.body){
            this.appService.setPopin(err.error.body)
            
          }

          this.loaderService.hide()
        })
      })
  }

  showHidePassword() {
    this.showPassword = !this.showPassword
  }

  ngOnDestroy(){
    this._destroyed.next()
    this._destroyed.complete()
  }
}
